{
  "AGENT_BOTS": {
    "HEADER": "Boty",
    "LOADING_EDITOR": "Ładowanie edytora...",
    "DESCRIPTION": "Agent Bots are like the most fabulous members of your team. They can handle the small stuff, so you can focus on the stuff that matters. Give them a try.You can manage your bots from this page or create new ones using the 'Configure new bot' button.",
    "LEARN_MORE": "Learn about agent bots",
    "GLOBAL_BOT": "Bot systemowy",
    "GLOBAL_BOT_BADGE": "System",
    "AVATAR": {
      "SUCCESS_DELETE": "Awatar bota został pomyślnie usunięty",
      "ERROR_DELETE": "Błąd podczas usuwania awatara bota, spróbuj ponownie"
    },
    "BOT_CONFIGURATION": {
      "TITLE": "Wybierz bota agenta",
      "DESC": "Przypisz Bota Agenta do swojej skrzynki odbiorczej. Mogą oni obsługiwać wstępne rozmowy i przekazywać je do żywego agenta, gdy jest to konieczne.",
      "OPTION": "{name} ({description})",
      "SUBMIT": "Aktualizuj",
      "DISCONNECT": "Odłącz bota",
      "SUCCESS_MESSAGE": "Pomyślnie zaktualizowano bota agenta.",
      "DISCONNECTED_SUCCESS_MESSAGE": "Pomyślnie odłączono bota agenta.",
      "ERROR_MESSAGE": "Nie udało się zaktualizować bota agenta. Proszę spróbować ponownie.",
      "DISCONNECTED_ERROR_MESSAGE": "Nie udało się odłączyć bota agenta. Proszę spróbować ponownie.",
      "SELECT_PLACEHOLDER": "Wybierz bota",
      "COUNTRY_BOTS": {
        "TITLE": "Boty według kraju",
        "DESC": "Ta skrzynka obsługuje kilka krajów. Rozmowa trafia do bota swojego kraju: według sklepu Kaufland, platformy zamówienia z Allegro, a w przeciwnym razie języka, w którym pisze klient. Wszystkie pozostałe rozmowy trafiają do domyślnego bota powyżej.",
        "COUNTRY": "Wybierz kraj",
        "BOT": "Wybierz bota",
        "ADD": "Dodaj bota dla kraju",
        "REMOVE": "Usuń",
        "DEFAULT_REQUIRED": "Najpierw wybierz domyślnego bota. Bot kraju zastępuje go tylko dla tego kraju.",
        "DISCONNECT_ALL": "Odłącz wszystkie boty"
      }
    },
    "ADD": {
      "TITLE": "Konfiguruj nowego bota",
      "CANCEL_BUTTON_TEXT": "Anuluj",
      "API": {
        "SUCCESS_MESSAGE": "Bot dodany pomyślnie.",
        "ERROR_MESSAGE": "Nie udało się dodać bota. Proszę spróbować później."
      }
    },
    "LIST": {
      "404": "Nie znaleziono botów. Możesz stworzyć bota, klikając przycisk 'Konfiguruj nowego bota' ↗",
      "LOADING": "Pobieranie botów...",
      "TABLE_HEADER": {
        "DETAILS": "Szczegóły bota",
        "URL": "URL webhooka"
      },
      "TYPE": "Typ bota"
    },
    "DELETE": {
      "BUTTON_TEXT": "Usuń",
      "TITLE": "Usuń bota",
      "CONFIRM": {
        "TITLE": "Potwierdź usunięcie",
        "MESSAGE": "Czy na pewno chcesz usunąć {name}?",
        "YES": "Tak, usuń",
        "NO": "Nie, zachowaj"
      },
      "API": {
        "SUCCESS_MESSAGE": "Bot usunięty pomyślnie.",
        "ERROR_MESSAGE": "Nie udało się usunąć bota. Proszę spróbować ponownie."
      },
      "SUBMIT": "Usuń",
      "CANCEL_BUTTON_TEXT": "Anuluj",
      "DESCRIPTION": "Czy na pewno chcesz usunąć tego bota? Ta akcja jest nieodwracalna."
    },
    "EDIT": {
      "BUTTON_TEXT": "Edytuj",
      "TITLE": "Edytuj bota",
      "API": {
        "SUCCESS_MESSAGE": "Bot zaktualizowany pomyślnie.",
        "ERROR_MESSAGE": "Nie udało się zaktualizować bota. Proszę spróbować ponownie."
      },
      "LOADING": "Pobieranie botów...",
      "CANCEL_BUTTON_TEXT": "Anuluj"
    },
    "FORM": {
      "AVATAR": {
        "LABEL": "Awatar bota"
      },
      "NAME": {
        "LABEL": "Nazwa bota",
        "PLACEHOLDER": "Wprowadź nazwę bota",
        "REQUIRED": "Nazwa bota jest wymagana"
      },
      "DESCRIPTION": {
        "LABEL": "Opis",
        "PLACEHOLDER": "Co robi ten bot?"
      },
      "WEBHOOK_URL": {
        "LABEL": "URL webhooka",
        "PLACEHOLDER": "https://example.com/webhook",
        "REQUIRED": "URL webhooka jest wymagany"
      },
      "ERRORS": {
        "NAME": "Nazwa bota jest wymagana",
        "URL": "URL webhooka jest wymagany",
        "VALID_URL": "Wprowadź prawidłowy URL rozpoczynający się od http:// lub https://"
      },
      "CANCEL": "Anuluj",
      "CREATE": "Utwórz bota",
      "UPDATE": "Aktualizuj bota"
    },
    "WEBHOOK": {
      "DESCRIPTION": "Skonfiguruj bota webhook, aby zintegrować go z usługami niestandardowymi. Bot będzie otrzymywał i przetwarzał zdarzenia z rozmów oraz może na nie odpowiadać."
    },
    "TYPES": {
      "WEBHOOK": "Bot webhook",
      "CSML": "Bot CSML"
    },
    "CSML_BOT_EDITOR": {
      "NAME": {
        "LABEL": "Nazwa bota",
        "PLACEHOLDER": "Nazwij swojego bota.",
        "ERROR": "Nazwa bota jest wymagana."
      },
      "DESCRIPTION": {
        "LABEL": "Opis bota",
        "PLACEHOLDER": "Co robi ten bot?"
      },
      "BOT_CONFIG": {
        "ERROR": "Proszę wprowadzić konfigurację bota CSML powyżej.",
        "API_ERROR": "Twoja konfiguracja CSML jest nieprawidłowa. Proszę ją poprawić i spróbować ponownie."
      },
      "SUBMIT": "Zweryfikuj i zapisz"
    }
  }
}
